module.exports = __webpack_public_path__ + "img/vip-customer-service.a6adbba5.png";